// import Axios from 'axios'
import VojoApi from '../../services/VojoApi'
import { findLocations } from './queries'

export const getLocations = async (functionId?: string) => {
  const vojoApi = new VojoApi()
  vojoApi.createInstance()
  return (await vojoApi.instance.get('/graphql', { params: { query: findLocations(functionId) } })).data.data.findLocations
}
